import React from 'react'
import { CardFrame, PageContainer, Pill } from '../ui'

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

function formatTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

function statusTone(status) {
  if (status === 'completed') return 'success'
  if (status === 'ready') return 'info'
  if (status === 'cancelled') return 'danger'
  return 'neutral'
}

function statusLabel(status) {
  if (status === 'completed') return 'Completed'
  if (status === 'ready') return 'Ready'
  if (status === 'cancelled') return 'Cancelled'
  return 'Draft'
}

function FeedItem({ session, reportName, onClick }) {
  const date = session.scheduledAt || session.createdAt
  const dateLabel = formatDate(date) + (session.scheduledAt ? ` at ${formatTime(date)}` : '')

  return (
    <CardFrame
      as="article"
      kind="overview"
      title={reportName}
      onTitleClick={onClick}
      titleAriaLabel={`Open session for ${reportName}`}
      headerRight={<Pill tone={statusTone(session.status)}>{statusLabel(session.status)}</Pill>}
      data-testid="feed-item"
    >
      <p className="team-feed__date">{dateLabel}</p>
    </CardFrame>
  )
}

export function TeamFeed({ feedSessions, reports, loading, onSelectReportSession }) {
  const reportMap = {}
  for (const r of reports) {
    reportMap[r.reportId] = r.reportName || r.reportEmail
  }

  return (
    <PageContainer as="main" className="team-feed" aria-label="Team feed">
      <h1 className="team-feed__heading">Recent sessions</h1>
      <p className="team-feed__subheading">Activity across your direct reports</p>
      {loading ? (
        <p className="team-feed__loading">Loading...</p>
      ) : feedSessions.length === 0 ? (
        <p className="team-feed__empty">No recent sessions across your reports.</p>
      ) : (
        <div className="team-feed__list" data-testid="feed-list">
          {feedSessions.map((s) => (
            <FeedItem
              key={s.sessionId}
              session={s}
              reportName={reportMap[s.userId] || 'Unknown'}
              onClick={() => onSelectReportSession(s.userId, s.sessionId)}
            />
          ))}
        </div>
      )}
    </PageContainer>
  )
}
